import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Auth/auth.css';
import { API_BASE } from './config/api';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState(null);
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setError('Missing payment session information');
        setVerifying(false);
        return;
      }

      try {
        console.log('Verifying payment with session ID:', sessionId);
        
        const response = await fetch(`${API_BASE}/api/verify-payment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id: sessionId }),
        });

        const data = await response.json();
        console.log('Payment verification response:', data);

        if (!response.ok) {
          console.error('Payment verification failed:', data);
          throw new Error(data.details || data.error || 'Failed to verify payment');
        }

        if (data.success) {
          console.log('Payment verified successfully:', data.subscription);
          setSubscriptionInfo(data.subscription);
          setVerifying(false);
          
          // Redirect to login after 5 seconds
          setTimeout(() => {
            navigate('/login?payment=success');
          }, 5000);
        } else {
          throw new Error(data.error || 'Payment verification failed');
        }
      } catch (err) {
        console.error('Payment verification error:', err);
        console.error('Error details:', err.message);
        setError(err.message);
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  if (verifying) {
    return (
      <div className="auth-wrapper">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 24px',
            borderRadius: '50%',
            background: 'rgba(59, 130, 246, 0.1)',
            border: '3px solid rgba(59, 130, 246, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div className="spinner" style={{ 
              width: '40px', 
              height: '40px', 
              border: '4px solid rgba(59, 130, 246, 0.3)',
              borderTopColor: '#3b82f6',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
          </div>

          <h1 style={{ color: '#3b82f6', marginBottom: '16px' }}>Verifying Payment...</h1>
          
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            Please wait while we activate your subscription.
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-wrapper">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 24px',
            borderRadius: '50%',
            background: 'rgba(239, 68, 68, 0.1)',
            border: '3px solid rgba(239, 68, 68, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{ fontSize: '48px', color: '#ef4444' }}>✕</div>
          </div>

          <h1 style={{ color: '#ef4444', marginBottom: '16px' }}>Verification Failed</h1>
          
          <div style={{
            padding: '16px 20px',
            marginBottom: '24px',
            borderRadius: '8px',
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)'
          }}>
            <p style={{ color: '#ef4444', fontSize: '14px', margin: 0 }}>
              {error}
            </p>
          </div>

          <button 
            className="button"
            onClick={() => navigate('/login')}
            style={{ width: '100%' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 24px',
          borderRadius: '50%',
          background: 'rgba(34, 197, 94, 0.1)',
          border: '3px solid rgba(34, 197, 94, 0.3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ fontSize: '48px', color: '#22c55e' }}>✓</div>
        </div>

        <h1 style={{ color: '#22c55e', marginBottom: '16px' }}>Payment Successful!</h1>
        
        <div style={{
          padding: '16px 20px',
          marginBottom: '24px',
          borderRadius: '8px',
          background: 'rgba(34, 197, 94, 0.1)',
          border: '1px solid rgba(34, 197, 94, 0.3)'
        }}>
          <p style={{ color: '#22c55e', fontSize: '16px', fontWeight: '600', margin: '0 0 8px 0' }}>
            Your account is now active!
          </p>
          <p style={{ color: '#9ca3af', fontSize: '14px', margin: 0 }}>
            Your {subscriptionInfo?.subscriptionType} subscription has been activated successfully.
          </p>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            Redirecting to login in 5 seconds...
          </p>
        </div>

        <button 
          className="button"
          onClick={() => navigate('/login')}
          style={{ width: '100%' }}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
